export enum MatchType {
  PARTIAL = 'partial',
  EXACT = 'exact',
}

enum PossibleSearchOptions {
  EXTERNAL_ID = 'external_id',
  EMAIL_ADDRESSES = 'email_addresses',
  BUSINESS_NAME = 'business_name',
  USER_NAME = 'user_name',
  PHONE_NUMBERS = 'phone_numbers',
  TITLE = 'title',
  DESCRIPTION = 'description',
  NAME = 'name',
  ID = 'id', // Only non-CGDO have unit21_id search
  FIRST_NAME = 'first_name',
  MIDDLE_NAME = 'middle_name',
  LAST_NAME = 'last_name',
  CONTENT = 'content',
}

export enum EntitySearchOptions {
  EXTERNAL_ID = PossibleSearchOptions.EXTERNAL_ID,
  EMAIL_ADDRESSES = PossibleSearchOptions.EMAIL_ADDRESSES,
  BUSINESS_NAME = PossibleSearchOptions.BUSINESS_NAME,
  USER_NAME = PossibleSearchOptions.USER_NAME,
  PHONE_NUMBERS = PossibleSearchOptions.PHONE_NUMBERS,
  FIRST_NAME = PossibleSearchOptions.FIRST_NAME,
  MIDDLE_NAME = PossibleSearchOptions.MIDDLE_NAME,
  LAST_NAME = PossibleSearchOptions.LAST_NAME,
}

export enum TransactionEventSearchOptions {
  EXTERNAL_ID = PossibleSearchOptions.EXTERNAL_ID,
}

export enum ActionEventSearchOptions {
  EXTERNAL_ID = PossibleSearchOptions.EXTERNAL_ID,
}

export enum InstrumentSearchOptions {
  EXTERNAL_ID = PossibleSearchOptions.EXTERNAL_ID,
}

export enum RuleSearchOptions {
  ID = PossibleSearchOptions.ID,
  TITLE = PossibleSearchOptions.TITLE,
  DESCRIPTION = PossibleSearchOptions.DESCRIPTION,
}

export enum CaseSearchOptions {
  ID = PossibleSearchOptions.ID,
  TITLE = PossibleSearchOptions.TITLE,
  DESCRIPTION = PossibleSearchOptions.DESCRIPTION,
}

export enum AlertSearchOptions {
  ID = PossibleSearchOptions.ID,
  EXTERNAL_ID = PossibleSearchOptions.EXTERNAL_ID,
  TITLE = PossibleSearchOptions.TITLE,
  DESCRIPTION = PossibleSearchOptions.DESCRIPTION,
}

export enum TeamSearchOptions {
  ID = PossibleSearchOptions.ID,
  NAME = PossibleSearchOptions.NAME,
  DESCRIPTION = PossibleSearchOptions.DESCRIPTION,
}

export enum NotesSearchOptions {
  CONTENT = PossibleSearchOptions.CONTENT,
}

export enum OldEntitySearchType {
  EXACT_EXTERNAL_ID = 'exact_external_id',
  EXTERNAL_ID = 'external_id',
  NAME = 'name',
  USER_NAME = 'user_name',
  EMAIL_ADDRESS = 'email_address',
  PHONE_NUMBERS = 'phone_numbers',
}
